import React, {useState, useCallback, useEffect, useContext} from 'react';
import {Context} from '../AppContext';
import {errorHandler} from '../errors';

function genId() {
  return Math.random();
}

export default function useCartItemTable({order}) {
  const app = useContext(Context);
  const [spec, setSpec] = useState(null);
  const [cart, setCart] = useState(() => {
    if (order) {
      try {
        return JSON.parse(order.cart);
      } catch {}
    }
    if (app.state.cart?.items) {
      app.state.cart.items = app.state.cart.items.map((item) => ({
        ...item,
        key: genId(),
      }));
    }

    return app.state.cart;
  });

  useEffect(() => {
    if (!order) {
      if (app.state.cart?.items) {
        app.state.cart.items = app.state.cart.items.map((item) => ({
          ...item,
          key: genId(),
        }));
      }
      setCart(app.state.cart);
    }
  }, [app.state.cart, order]);

  useEffect(() => {
    (async () => {
      try {
        let resp = await app.actions.getSpec(cart.version);
        setSpec(resp);
      } catch (err) {
        console.warn(err);
      }
    })();
  }, [app.actions, cart]);

  const removeItem = async (index) => {
    app.actions.setLoading(true);
    try {
      await app.actions.removeItem(index);
    } catch (err) {
      errorHandler(err);
    }
    app.actions.setLoading(false);
  };

  const onConfigChange = useCallback(
    async (itemIndex, config, product) => {
      app.actions.setLoading(true);
      try {
        await app.actions.updateItem(itemIndex, {
          name: product.name,
          config,
        });
      } catch (err) {
        errorHandler(err);
      }

      app.actions.setLoading(false);
    },
    [app.actions],
  );

  let result = {
    spec,
    cart,
    removeItem,
    onConfigChange,
  };

  return result;
}
